import React, { useContext, useEffect, useState } from "react";
import { useLocation, Navigate, useNavigate } from "react-router-dom";
import axios from "axios";
import {
  BASE_URL,
  CLIENT_ADMIN_ROLE_ID,
  CLIENT_ID,
  REDIRECT_URI,
  TOKEN_URI,
  USER_ROLE_ID,
  VF_ADMIN_ROLE_ID,
  toastConfig,
} from "../constants/constant";
import { Service } from "../services/service";
import Loader from "./loader/Loader";
import { useDispatch, useSelector } from "react-redux";
import { updateBBUser, updateCurrentUser } from "../reduxSlices/userSlice";
import { useCallback } from "react";
import { AuthContext } from "react-oauth2-code-pkce";
import { toast } from "react-toastify";

const service = new Service();

const BlackbaudCallback = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [loading, setLoading] = useState(true);
  const [accessToken, setAccessToken] = useState("");
  const location = useLocation();
  const urlParams = new URLSearchParams(location.search);
  const code = urlParams.get("code");
  const error = urlParams.get("error");
  const codeVerifier =
    sessionStorage.getItem("PKCE_code_verifier") ||
    localStorage.getItem("PKCE_code_verifier");
  // const user_data = localStorage.getItem("user_data");
  const searchParams = localStorage.getItem("searchParams");
  // const { token, tokenData, loginInProgress } = useContext(AuthContext);
  const isConnect = localStorage.getItem("isConnect");
  const isFirstLogin = localStorage.getItem("isFirstLogin");
  const isSwitchEnv = localStorage.getItem("isSwitchEnv");
  const environment_id = localStorage.getItem("environment_id");
  const email = localStorage.getItem("email");
  const userData = useSelector((state) => state?.user);
  const userRole = userData?.userRoleId;
  const isVfAdmin = userRole?.includes(VF_ADMIN_ROLE_ID);
  const isClientAdmin = userRole?.includes(CLIENT_ADMIN_ROLE_ID);

  const client_id = CLIENT_ID;
  const redirectUri = REDIRECT_URI;

  const config = {
    code: code,
    client_id: client_id,
    redirect_uri: redirectUri,
    grant_type: "authorization_code",
    code_verifier: codeVerifier,
  };

  const header = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  };

  const fetchToken1 = async () => {
    console.log("Redirected to token");
    // if (code) {
    if (isFirstLogin || isSwitchEnv) {
      saveUserLogin();
    }
    else if (!isConnect) {
      setLoading(true);
      await axios
        .post(TOKEN_URI, config, header)
        .then((response) => {
          const bbUserData = response.data;
          const accessToken = bbUserData.access_token;
          const email = bbUserData.email;
          console.log("bb_data", bbUserData);
          dispatch(updateBBUser(bbUserData));
          localStorage.setItem("email", email);
          localStorage.setItem("bb_access_token", accessToken);
          setAccessToken(accessToken);
          if (bbUserData) {
            fetchUserLoginData(bbUserData);
          }
          setLoading(false);
        })
        .catch((error) => {
          if (error?.response?.status === 400) {
            // navigate(searchParams);
            console.log("login called from<<<<<<<<<<<<<<<<<<<<<Blackbaudcallback - 91");
            login();
          }
          localStorage.removeItem("isConnect");
          console.error("Error exchanging code for access token:", error);
          setLoading(true);
        });
    }
    else {
      connectToEnvironment();
    }
    //}
  };

  const fetchToken = useCallback(fetchToken1, [code]);

  useEffect(() => {
    //if(code && codeVerifier){
    localStorage.setItem("PKCE_code_verifier", codeVerifier);
    fetchToken();
    //}
  }, []);

  const saveUserLogin = async () => {
    let url = `/api/User/CheckUserLogin?email=` + email;
    let params = {
      environmentId: environment_id,
      code: code,
      redirectUri: redirectUri
    };
    try {
      setLoading(true);
      let res = await service.newPostApi(url, params, null);
      let response = res.data;
      if (response.success == false) {
        if (response.errorMessage === "Unauthorized Access") {
          localStorage.clear();
        }
        toast.error(response.errorMessage, toastConfig);
        setLoading(false);
        navigate("/login");
      }
      else {
        //get user tokens and then call login api
        const bbtUserData = response.data;
        const bbUserData = {
          email: bbtUserData?.emailId,
          access_token: bbtUserData?.token,
          environment_id: bbtUserData?.environmentId,
          legal_entity_id: bbtUserData?.legalEntityId
        }
        const accessToken = bbUserData.access_token;
        const email = bbUserData.email;
        console.log("bb_data", bbUserData);
        dispatch(updateBBUser(bbUserData));
        localStorage.setItem("email", email);
        localStorage.setItem("bb_access_token", accessToken);
        setAccessToken(accessToken);
        if (bbUserData) {
          fetchUserLoginData(bbUserData);
        }
        setLoading(false);
        localStorage.setItem("isFirstLogin", false);
        localStorage.setItem("isSwitchEnv", false);
      }
    } catch (err) {
      console.log(err);
      toast.error(err.message, toastConfig);
      setLoading(false);
    }
  };

  // const fetchUserLoginData = async (bbUserData) => {
  //   setLoading(true);
  //   const url = `${BASE_URL}/api/User/UserLogin`;
  //   const params = { email: bbUserData?.email };
  //   const user_token = localStorage.getItem("bb_access_token");
  //   try {
  //     await service.testGetApi(url, params, user_token).then(
  //       (response) => {
  //         const userData = response?.data;
  //         if (userData?.data && userData?.success) {
  //           console.log("userData<<<<<", userData);
  //           const userRole = userData?.data?.roles?.map((item) => item.roleId);
  //           const envIsActive = userData?.data?.environments?.map(
  //             (item) => item?.isActive
  //           );
  //           const userIsActive = userData?.data?.isActive;
  //           const isActive = envIsActive && userIsActive;
  //           console.log("isActive<<<<<", isActive);
  //           const environmentId = userData?.data?.environments?.map(
  //             (item) => item?.environmentId
  //           );
  //           const organisationId = userData?.data?.organization?.organizationId;
  //           console.log("user_data", userRole, environmentId, organisationId);
  //           localStorage.setItem("user_data", JSON.stringify(userData.data));
  //           dispatch(updateCurrentUser(userData));
  //           if (
  //             userRole?.includes(VF_ADMIN_ROLE_ID) &&
  //             // userIsActive &&
  //             searchParams === "/admin"
  //           ) {
  //             navigate("/dashboard");
  //             localStorage.setItem("showDisclaimer", true);
  //             localStorage.setItem("showAlert", true);
  //           } else if (
  //             (userRole?.includes(USER_ROLE_ID) ||
  //               userRole?.includes(CLIENT_ADMIN_ROLE_ID)) &&
  //             environmentId?.includes(bbUserData?.environment_id) &&
  //             organisationId === bbUserData?.legal_entity_id &&
  //             // isActive &&
  //             searchParams === "/"
  //           ) {
  //             navigate(userData?.data?.isNew ? "/user-review" : "/dashboard");
  //             localStorage.setItem("showDisclaimer", true);
  //             localStorage.setItem("showAlert", true);
  //           } else if (
  //             (userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
  //               userRole?.includes(VF_ADMIN_ROLE_ID)) &&
  //             environmentId?.includes(bbUserData?.environment_id) &&
  //             organisationId === bbUserData?.legal_entity_id &&
  //             // isActive &&
  //             searchParams === "/admin"
  //           ) {
  //             navigate(
  //               userData?.data?.isNew && userRole?.includes(CLIENT_ADMIN_ROLE_ID)
  //                 ? "/setup-organisation"
  //                 : "/dashboard"
  //             );
  //             localStorage.setItem("showDisclaimer", true);
  //             localStorage.setItem("showAlert", true);
  //           } else {
  //             navigate("/accessdenied");
  //           }
  //         } else {
  //           localStorage.removeItem("user_data");
  //           navigate("/accessdenied");
  //           toast.warning(userData?.errorMessage, toastConfig);
  //         }
  //         setLoading(false)
  //       }
  //     )
  //       .catch(
  //         (error) => {
  //           console.error("Error fetching data:", error);
  //           setLoading(true);
  //         }
  //       );
  //   } catch (error) {  
  //   }
  // };

  const fetchUserLoginData = async (bbUserData) => {
    setLoading(true);
    const url = `${BASE_URL}/api/User/UserLogin`;
    const params = { email: bbUserData?.email };
    const user_token = localStorage.getItem("bb_access_token");
    try {
      await service.testGetLoginApi(url, params, user_token).then(
        (response) => {
          const userData = response?.data;
          if (userData?.data && userData?.success) {
            console.log("userData<<<<<", userData);
            localStorage.setItem("isFirstLogin", false);
            localStorage.setItem("isSwitchEnv", false);
            const userRole = userData?.data?.roles?.map((item) => item.roleId);
            const envIsActive = userData?.data?.environments?.map(
              (item) => item?.isActive
            );
            const userIsActive = userData?.data?.isActive;
            const isActive = envIsActive && userIsActive;
            console.log("isActive<<<<<", isActive);
            const environmentId = userData?.data?.environments?.map(
              (item) => item?.environmentId
            );
            const organisationId = userData?.data?.organization?.organizationId;
            console.log("user_data", userRole, environmentId, organisationId);
            localStorage.setItem("user_data", JSON.stringify(userData.data));
            dispatch(updateCurrentUser(userData));
            if (
              userRole?.includes(VF_ADMIN_ROLE_ID) &&
              // userIsActive &&
              searchParams === "/admin"
            ) {
              navigate("/dashboard");
              localStorage.setItem("showDisclaimer", true);
              localStorage.setItem("showAlert", true);
            } else if (
              (userRole?.includes(USER_ROLE_ID) ||
                userRole?.includes(CLIENT_ADMIN_ROLE_ID)) &&
              environmentId?.includes(bbUserData?.environment_id) &&
              organisationId === bbUserData?.legal_entity_id &&
              // isActive &&
              searchParams === "/"
            ) {
              navigate(userData?.data?.isNew ? "/user-review" : "/dashboard");
              localStorage.setItem("showDisclaimer", true);
              localStorage.setItem("showAlert", true);
            } else if (
              (userRole?.includes(CLIENT_ADMIN_ROLE_ID) ||
                userRole?.includes(VF_ADMIN_ROLE_ID)) &&
              environmentId?.includes(bbUserData?.environment_id) &&
              organisationId === bbUserData?.legal_entity_id &&
              // isActive &&
              searchParams === "/admin"
            ) {
              navigate(
                userData?.data?.isNew && userRole?.includes(CLIENT_ADMIN_ROLE_ID)
                  ? "/setup-organisation"
                  : "/dashboard"
              );
              localStorage.setItem("showDisclaimer", true);
              localStorage.setItem("showAlert", true);
            } else {
              navigate("/accessdenied");
            }
          } else {
            localStorage.removeItem("user_data");
            navigate("/accessdenied");
            toast.warning(userData?.errorMessage, toastConfig);
          }
          setLoading(false)
        }
      )
        .catch(
          (error) => {
            console.error("Error fetching data:", error);
            setLoading(true);
          }
        );
    } catch (error) {
    }
  };

  const connectToEnvironment = async () => {
    setLoading(true);
    const url = `${BASE_URL}/api/Environment/ConnectToEnvironment`;
    const user_token = localStorage.getItem("bb_access_token");
    const params = {
      environmentId: environment_id,
      code: code,
      redirectUri: redirectUri,
    };
    try {
      const response = await service.testPutApi(url, params, user_token);
      const resp = response?.data;
      console.log("resprespresp", resp);
      localStorage.removeItem("isConnect");
      if (resp?.data && resp?.success) {
        setLoading(false);
        navigate("/environments");
        toast.success("Environment connected successfully", {
          ...toastConfig,
          style: {
            backgroundColor: "#4a67ad",
          },
        });
      } else {
        navigate("/environments");
        toast.warning(resp?.errorMessage, toastConfig);
      }
    } catch (error) {
      setLoading(false);
      navigate("/environments");
      toast.error(error?.message, toastConfig);
      console.error("Error while connect:", error);
      localStorage.removeItem("isConnect");
    }
  };

  if (loading) return <Loader />;
  if (error) return <Navigate to="/accessdenied" replace />;
  if (!accessToken && !code && !codeVerifier) {
    return <Navigate to={searchParams === "/admin" ? "/admin" : "/"} replace />;
  }
};

export default BlackbaudCallback;
